<template>
  <div class="loader"></div>
</template>

<script setup></script>

<style scoped></style>
